import { jsx as _jsx } from "react/jsx-runtime";
import { SocialsGeneratePosts as UISocialsGeneratePosts } from "@bluframe/mightychroma-mightytool-ui";
const GeneratePosts = (props) => (_jsx(UISocialsGeneratePosts, { ...props }));
export default GeneratePosts;
